import { channelPartnerWebhookQueryKeys as e } from "./useChannelPartnerWebhookQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminChannelPartnerWebhooksApi as n } from "@maat/api-main";
//#region src/channelPartnerWebhooks/useChannelPartnerWebhookEndpointQuery.ts
var r = (r, i) => t({
	queryKey: e.endpoint(r, i),
	queryFn: () => n.getEndpoint(r, { workspaceId: i }),
	enabled: !!(r && i)
});
//#endregion
export { r as useChannelPartnerWebhookEndpointQuery };
